import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CantidadPorTipoDto } from '@models/base/cantidadPorTipoDto.model';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { CreateMovimientoRequest } from '@models/movimiento/createMovimientoRequest.model';
import { DeleteMovimientoRequest } from '@models/movimiento/deleteMovimientoRequest.model';
import { MovimientoDto } from '@models/movimiento/movimientoDto.model';
import { MovimientoFilter } from '@models/movimiento/movimientoFilter.model';
import { UpdateMovimientoRequest } from '@models/movimiento/updateMovimientoRequest.model';
import { CreateMovimientoExpedienteRequest } from '@models/movimientoExpediente/createMovimientoExpedienteRequest.model';
import { MovimientoExpedienteDto } from '@models/movimientoExpediente/movimientoExpedienteDto.model';
import { MovimientoExpedienteFilter } from '@models/movimientoExpediente/movimientoExpedienteFilter.model';
import { UpdateMovimientoExpedienteRequest } from '@models/movimientoExpediente/updateMovimientoExpedienteRequest.model';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class MovimientoExpedienteService {

  constructor(
    private http:HttpClient
  ) { }

  create(createMovimientoExpedienteRequest:CreateMovimientoExpedienteRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/MovimientoExpediente/Create",createMovimientoExpedienteRequest);
  }

  update(updateMovimientoExpedienteRequest:UpdateMovimientoExpedienteRequest):Observable<any>
  {
    return  this.http.put<any>("/api/MovimientoExpediente/Update",updateMovimientoExpedienteRequest);
  }

  getAll():Observable<MovimientoExpedienteDto[]> {
    return   this.http.get<MovimientoExpedienteDto[]>("/api/MovimientoExpediente/GetAll");
  }

  getById(id:number):Observable<MovimientoExpedienteDto>{
    return  this.http.get<MovimientoExpedienteDto>("/api/MovimientoExpediente/GetById?id="+id);
  }


  getAllByIdExpediente(idExpediente:number):Observable<MovimientoExpedienteDto[]>{
    return  this.http.get<MovimientoExpedienteDto[]>("/api/MovimientoExpediente/GetAllByIdExpediente?idExpediente="+idExpediente);
  }

 deleteLogic(deleteMovimientoRequest:DeleteMovimientoRequest):Observable<boolean>
  {
    return  this.http.put<any>("/api/MovimientoExpediente/DeleteLogic",deleteMovimientoRequest);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/MovimientoExpediente/Delete?id=" + id);
    else
      return of(null)
  }

  getAllByFilter(movimientoExpedienteFilter:MovimientoExpedienteFilter):Observable<MovimientoExpedienteDto[]> {
    return   this.http.post<MovimientoExpedienteDto[]>("/api/MovimientoExpediente/GetAllMovimientosExpedienteByFilter",movimientoExpedienteFilter);
  }

}
